import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Counter.scss";

const Counter = ({Module, pathname, leadooPageSlot}) => {

    var counter_list = Module?.statics_blocks || Module?.statistics_component;
    
    return (
        <React.Fragment>
            <section className="counter">
                <Container>
                    <Row>
                        <Col>
                            <div className="counter-wrapper">

                                {counter_list?.length > 0 && counter_list?.map((item, index) => {
                                    return(
                                        <div className="counter-wrap">
                                            <div className="counter-box">
                                                <span className="box">
                                                    <i className={item.icon_class}></i>
                                                </span>
                                            </div>
                                            <div className="counter-content">
                                                <h3>{item.heading}</h3>
                                                <p>{item.content}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* {leadooPageSlot?.sell_property &&
                <ld-slot name={leadooPageSlot[pathname]}></ld-slot>
            } */}
        </React.Fragment>

    );
};
export default Counter;
